import "./LandingPage.scss";
import Navigation from "@components/Navigation";
import { IconChevronRight, IconPlayerPlay } from "@tabler/icons-react";
import LandingSections from "./LandingSections";

/* ============================================================
   Main Component
============================================================ */

export default function LandingPage() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="lp-root">
      <Navigation variant="landing" />

      {/* ─── HERO ─── */}
      <section className="lp-hero" id="hero">
        <div className="lp-hero-card">
          {/* Left: person photo */}
          <div className="lp-hero-card-right" data-aos="fade-right">
            <img
              className="lp-hero-person-img"
              src="/img/studio/less_cut_wearing_vr.png"
              alt="Person wearing Oculera VFA Headset"
            />
          </div>

          {/* Right: text content */}
          <div className="lp-hero-card-left" data-aos="fade-left" data-aos-delay="150">
            <div className="lp-hero-title-block">
              <div className="lp-hero-title-bar" />
              <div className="lp-hero-titles">
                <div className="lp-hero-title-line1">VISUAL FIELD</div>
                <div className="lp-hero-title-line2">TESTING</div>
              </div>
            </div>

            <p className="lp-hero-subtitle">
              Oculera VFA is the world's most comprehensive VR-based visual field analyzer.
              Portable, precise, and patient-friendly.
            </p>

            <div className="lp-hero-ctas">
              <a
                href="#contact"
                className="lp-btn-orange"
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo("contact");
                }}
              >
                Contact Us <IconChevronRight size={16} />
              </a>
              <button className="lp-hero-video-btn" onClick={() => scrollTo("how-it-works")}>
                <span className="play-icon">
                  <IconPlayerPlay size={14} fill="white" color="white" />
                </span>
                Watch How It Works
              </button>
            </div>

            <div className="lp-hero-certs">
              <div className="lp-trust-badges">
                <span className="lp-cert-item">
                  <img className="lp-cert-logo" src="/img/certs/2.png" alt="CE 1984" />
                  <span className="lp-cert-note">1984</span>
                </span>
              </div>

              <div className="lp-hero-reg-note">
                <span>FDA listed</span>
                <span>Registered with MHRA (UK)</span>
                <span>QMS certified to ISO 13485:2016</span>
              </div>
            </div>
          </div>

          {/* Bottom brand overlay */}
          <div className="lp-hero-card-brand">
            <img src="/img/logo_with_border.png" alt="Oculera" className="lp-hero-brand-logo" />
          </div>
        </div>

        <div className="lp-hero-url">
          www.<strong>oculera.health</strong>
        </div>
      </section>

      <LandingSections />
    </div>
  );
}
